export default __webpack_public_path__ + "static/role_5-214c0b1957ce79b7e5c46e66455f04e4.png";